import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { PutRequest } from "../../services/ApiClientService"
import type { SelectionOptionStockEntity } from "../../Objects/Selection/SelectionOptionStockEntity"

interface SelectionOptionStockQuickEditRequest {
  items: SelectionOptionStockEntity[]
}

export type SelectionOptionStockTarget = "meal" | "drink" | "combo"

const SELECTION_STOCK_ENDPOINT_BY_TARGET: Record<SelectionOptionStockTarget, string> = {
  meal: API_ROUTES.MEAL.SELECTION_STOCK,
  drink: API_ROUTES.DRINK.SELECTION_STOCK,
  combo: API_ROUTES.COMBO.SELECTION_STOCK,
}

export const useSaveSelectionOptionStock = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const saveSelectionOptionStock = async (
    target: SelectionOptionStockTarget,
    items: SelectionOptionStockEntity[],
  ): Promise<boolean> => {
    if (items.length === 0) return true

    try {
      enableLoad()

      const endpoint = SELECTION_STOCK_ENDPOINT_BY_TARGET[target]

      const response = await PutRequest<number[], SelectionOptionStockQuickEditRequest>(endpoint, { items })

      if (!response.success) throw new Error(response.message)

      return true
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)

      return false
    } finally {
      disableLoad()
    }
  }

  return { saveSelectionOptionStock }
}
